import { APP_INITIALIZER, APP_BOOTSTRAP_LISTENER, ModuleWithProviders, NgModule } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { GoogleAnalyticsInitializer } from "./initializers/google-analytics.initializer";
import { GoogleAnalyticsCommand } from "./interfaces/google-analytics-command";
import { GoogleAnalyticsSettings } from "./interfaces/google-analytics-settings";
import { GoogleAnalyticsService } from "./service/google-analytics.service";
import { NG_GOOGLE_ANALYTICS_SETTINGS_TOKEN } from "./tokens/google-analitics-settings-token";
import { NG_GTAG_FN } from "./tokens/gtag-token";
import { TrackingCodeService } from "./service/tracking-code.service";

@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [GoogleAnalyticsService, TrackingCodeService],
})
export class AnalyticsModule {
  /**
   * You should provide a valid Google TrackingCode. This code will be provided to the entire application by
   * `NG_GOOGLE_ANALYTICS_SETTINGS_TOKEN` token. You can inject this code in you components if you like by
   * use the following injection code `@Inject(NG_GOOGLE_ANALYTICS_SETTINGS_TOKEN) gaConfig: GoogleAnalyticsSettings`
   *
   * @param trackingCode The Google Tracking Code
   * @param initCommands When placed, it will run any GA Commands in sequence after setup GA environment.
   * @param uri When placed, it will change the default js URI to the provided one.
   * @param enableTracing When true, trace GA tracking errors on production mode.
   * @param nonce When placed, nonce will be added to script tag.
   */
  static forRoot(
    trackingCode: string,
    initCommands: GoogleAnalyticsCommand[] = [],
    uri?: string,
    enableTracing?: boolean,
    nonce?: string
  ): ModuleWithProviders<AnalyticsModule> {
    return {
      ngModule: AnalyticsModule,
      providers: [
        {
          provide: NG_GOOGLE_ANALYTICS_SETTINGS_TOKEN,
          useValue: {
            trackingCode,
            initCommands,
            uri,
            enableTracing,
            nonce,
          } as GoogleAnalyticsSettings,
        },
        {
          provide: APP_INITIALIZER,
          multi: true,
          useFactory: GoogleAnalyticsInitializer,
          deps: [NG_GOOGLE_ANALYTICS_SETTINGS_TOKEN, NG_GTAG_FN, DOCUMENT, TrackingCodeService],
        },
      ],
    };
  }
}
